import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../@config/endpoints';
import { MobileConfigurationDto } from '../@models';

@Injectable({
  providedIn: 'root'
})
export class MobileConfigurationService {
  constructor(private http: HttpClient) {}

  getMobileConfiguration(): Observable<MobileConfigurationDto | null> {
    return this.http.get<{ result: MobileConfigurationDto }>(ENDPOINTS.getMobileConfiguration()).pipe(
      map((response: { result: MobileConfigurationDto }) => response?.result || null)
    );
  }
}
